import _pick from 'lodash/pick';

import { getUri, url } from 'react-redux-app/lib/modules/routing/utils';

import { handler as loginHandler, params as loginParams } from './loginHandler';
import { handler as socialNetworkHandler, params as socialNetworkParams } from './socialNetworkHandler';


const PARAM_NAME_EXTERNAL_COMMAND = 'externalCommand';
const EXTERNAL_COMMAND_LOGIN_WITH_TOKEN = 'login-with-token';

const externalCommandActionMap = {
  [EXTERNAL_COMMAND_LOGIN_WITH_TOKEN]: {
    handler: loginHandler,
    commandParams: loginParams,
  },
  socialNetworkAuthError: {
    handler: socialNetworkHandler,
    commandParams: socialNetworkParams,
  },
};

export default reduxStore => {
  const { getState, dispatch } = reduxStore;
  return function externalCommandHandler(nextState, successCallback, errorCallback) {
    const queryParams = url.parseQuery(nextState.location.search);
    const externalCommand = queryParams[PARAM_NAME_EXTERNAL_COMMAND];

    if (!externalCommandActionMap?.[externalCommand]) {
      successCallback();
      return;
    }

    // Note: remove an external command and params from a currentUri
    const currentUri = getUri(nextState.location);
    let newUri = url.removeQueryParams(currentUri, [PARAM_NAME_EXTERNAL_COMMAND]);

    let commandParams = {};
    const externalCommandParamsNames = externalCommandActionMap[externalCommand].commandParams;
    if (externalCommandParamsNames) {
      newUri = url.removeQueryParams(newUri, externalCommandParamsNames);
      commandParams = _pick(queryParams, externalCommandParamsNames);
    }

    const { handler } = externalCommandActionMap[externalCommand];
    new Promise((resolve, reject) => {
      handler(reduxStore, nextState, resolve, reject, commandParams, newUri);
    }).then(
      () => { successCallback(); },
      redirectUrl => { errorCallback(redirectUrl); }
    );
  };
};
